import { useEffect, useState } from "react";

export const SCHEDULE = [
  { day: "Duminică", open: null, close: null },
  { day: "Luni", open: "09:00", close: "17:00" },
  { day: "Marți", open: "09:00", close: "17:00" },
  { day: "Miercuri", open: "09:00", close: "17:00" },
  { day: "Joi", open: "09:00", close: "17:00" },
  { day: "Vineri", open: "09:00", close: "17:00" },
  { day: "Sâmbătă", open: "09:00", close: "12:00" },
];

const toMinutes = (t) => {
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

export function getShopStatus() {
  const ro = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Bucharest" }));
  const dayIdx = ro.getDay();
  const nowMins = ro.getHours() * 60 + ro.getMinutes();
  const today = SCHEDULE[dayIdx];

  let isOpen = false;
  let closingSoon = false;
  if (today.open) {
    const o = toMinutes(today.open);
    const c = toMinutes(today.close);
    isOpen = nowMins >= o && nowMins < c;
    closingSoon = isOpen && c - nowMins <= 60;
  }

  let nextOpenLabel = null;
  if (!isOpen) {
    for (let i = 0; i < 8; i++) {
      const idx = (dayIdx + i) % 7;
      const s = SCHEDULE[idx];
      if (!s.open) continue;
      if (i === 0 && nowMins >= toMinutes(s.open)) continue;
      const prefix = i === 0 ? "azi" : i === 1 ? "mâine" : s.day;
      nextOpenLabel = `Deschide ${prefix} la ${s.open}`;
      break;
    }
  }

  return {
    isOpen,
    closingSoon,
    today,
    dayIdx,
    nextOpenLabel,
    timeLabel: ro.toLocaleTimeString("ro-RO", { hour: "2-digit", minute: "2-digit" }),
  };
}

export function useShopStatus() {
  const [status, setStatus] = useState(getShopStatus);
  useEffect(() => {
    const t = setInterval(() => setStatus(getShopStatus()), 30000);
    return () => clearInterval(t);
  }, []);
  return status;
}
